import * as RadixTabs from '@radix-ui/react-tabs';
import * as React from 'react';
import { cn } from '../../lib/cn';

export interface TabItem { value: string; label: string; content: React.ReactNode }
export interface TabsProps {
  items: TabItem[];
  /** Неконтролируемый режим */
  defaultValue?: string;
  /** Контролируемый режим */
  value?: string;
  onValueChange?: (value: string) => void;
  /** Классы для панелей (например фиксированная min-height, чтобы вкладки не прыгали). */
  panelClassName?: string;
  /** Классы для списка триггеров (например равная ширина на узком экране). */
  listClassName?: string;
  dataTestId?: string;
}

export function Tabs({ items, defaultValue, value, onValueChange, panelClassName, listClassName, dataTestId }: TabsProps) {
  const isControlled = value !== undefined;
  return (
    <>
      <style>{`.rti-tab-panel[data-state="inactive"]{display:none}`}</style>
    <RadixTabs.Root
      data-testid={dataTestId}
      {...(isControlled
        ? { value, onValueChange }
        : { defaultValue: defaultValue ?? items[0]?.value, onValueChange })}
    >
      <RadixTabs.List
        className={cn(
          'mb-3 flex w-full gap-1 border-b border-[hsl(var(--ui-border))]',
          listClassName,
        )}
      >
        {items.map((item) => (
          <RadixTabs.Trigger
            key={item.value}
            value={item.value}
            className="min-w-0 flex-1 basis-0 px-2 py-2 text-center text-sm text-[hsl(var(--ui-muted-foreground))] data-[state=active]:border-b-2 data-[state=active]:border-[hsl(var(--ui-primary))] data-[state=active]:text-[hsl(var(--ui-foreground))] sm:px-3"
          >
            {item.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {items.map((item) => (
        <RadixTabs.Content key={item.value} value={item.value} forceMount className={cn('rti-tab-panel', 'outline-none', panelClassName)}>
          {item.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
    </>
  );
}
